import { useMemo } from 'react'

export const useMemberInitials = (memberName: string): string => {
    const initials = useMemo(() => {
        if (!memberName) return ''
        const names = memberName.split(' ')
        if (names.length === 1) {
            return names[0].charAt(0).toUpperCase()
        }
        return `${names[0].charAt(0).toUpperCase()}${names[names.length - 1].charAt(0).toUpperCase()}`
    }, [memberName])

    return initials
}
